module.exports = __webpack_public_path__ + "img/au_gallery_2.e2f7557d.jpg";